import { CollectionDb } from "../models/collection.db";

export const getDefaultFolderId = (curCollection?: null | CollectionDb) => {
  if (!curCollection) {
    return "";
  }
  if (curCollection.folders?.includes("default-wishlist") ?? false) {
    return "default-wishlist";
  } else if (curCollection.folders?.includes("default-packing") ?? false) {
    return "default-packing";
  } else if (curCollection.folders?.includes("default-inspiration") ?? false) {
    return "default-inspiration";
  } else {
    return "default-capsules";
  }
};
